import SetupStrategy from './setupStrategy';

export default class AppleSetupStrategy extends SetupStrategy {
  constructor(...params) {
    super(...params);
    this.upperName = 'Apple';
    this.vendor = 'apple';
  }

  properName() {
    return this.upperName;
  }

  getDeviceLinkingUrl() {
    return this.vendor;
  }

  openDeviceLinkingWindow() {
    if (!window.platform || window.platform !== 'ios') {
      this.eventBus.emit('toggleAlert', {
        message: 'Open the PWR Lab app on your iPhone to connect with Apple.',
        messageSize: 'p',
      });
    } else {
      window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify({
        type: 'linkApple',
      }));
      window.hkEnabled = true;

      // TODO: take this out when RHF ends
      this.bailOutHandle = setTimeout(() => {
        clearInterval(this.checkWindowHandle);
        this.checkWindowHandle = null;
        this.bailOut(true, () => {
          this.router.push({
            name: 'profile',
          });
        });
      }, 1000 * 45);
    }
  }
}
